module.exports = __webpack_public_path__ + "static/loreal-dc9f1308d4fc3c2d7e3f10a85be3480e.png";